import type { ExperimentConfig } from '@seek/candidate-feature-flag';

/*
 * Sample experiment configuration for LaunchDarkly:
 *
 * export const EXPERIMENT_ENABLE_CAREER_HUB_WEB_TEST = 'experiment-enable-career-hub-web-test';
 *
 * const enableCareerHubWebTestExperiment = {
 *  key: EXPERIMENT_ENABLE_CAREER_HUB_WEB_TEST,
 *  title: 'Experiment: Enable Career Hub Web Test',
 *  type: 'boolean',
 * } satisfies ExperimentConfig;
 *
 * export type EnableCareerHubWebTestExperiment = FeatureType<
 *  typeof enableCareerHubWebTestExperiment
 * >;
 */

export const launchDarklyExperiments: ExperimentConfig[] = [];
